import { z } from 'zod';
import { amountSchema } from '../common/amount.js';
import { paginationMetaSchema } from '../common/pagination.js';
import { branchRefSchema, employeeRefSchema } from '../common/refs.js';
import { accountRefSchema, debtorRefSchema, pageQueryShape, periodIsOrdered, periodQueryShape, PERIOD_ORDER_ISSUE, } from './common.js';
/**
 * سلة المحذوفات (debts.md section 8.3): deleted movements and deleted
 * accounts. Restoring re-applies a record; there is no permanent delete.
 */
export const TRASH_TYPES = ['MOVEMENTS', 'ACCOUNTS'];
export const trashTypeSchema = z.enum(TRASH_TYPES);
export const trashQuerySchema = z
    .object({
    type: trashTypeSchema.default('MOVEMENTS'),
    branchId: z.string().trim().min(1).optional(),
    /** On the deletion date. */
    ...periodQueryShape,
    ...pageQueryShape,
})
    .refine(periodIsOrdered, PERIOD_ORDER_ISSUE);
export const trashMovementSchema = z.object({
    id: z.string(),
    number: z.number().int(),
    reference: z.string(),
    account: accountRefSchema,
    branch: branchRefSchema,
    occurredAt: z.string(),
    debit: amountSchema,
    credit: amountSchema,
    statement: z.string().nullable(),
    employee: employeeRefSchema.nullable(),
    deletedAt: z.string(),
    deletedBy: employeeRefSchema.nullable(),
});
export const trashAccountSchema = z.object({
    id: z.string(),
    number: z.number().int(),
    /** اسم الحساب. */
    name: z.string(),
    debtor: debtorRefSchema,
    /** The debtor's phone, or the account's legacy phone text. */
    phone: z.string().nullable(),
    branch: branchRefSchema,
    balance: amountSchema,
    deletedAt: z.string(),
    deletedBy: employeeRefSchema.nullable(),
});
export const trashListSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('MOVEMENTS'),
        items: z.array(trashMovementSchema),
        meta: paginationMetaSchema,
    }),
    z.object({
        type: z.literal('ACCOUNTS'),
        items: z.array(trashAccountSchema),
        meta: paginationMetaSchema,
    }),
]);
//# sourceMappingURL=trash.js.map